import { type ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'

import { DataTableColumnHeader } from '@/components/data-table'
import { type TransactionRecord, type PaymentType } from '../types/transactions'
import { format } from 'date-fns'

const getPaymentTypeLabel = (type: PaymentType) => {
  switch (type) {
    case 'direct': return '直接充值'
    case 'pass': return '通行证购买'
    case 'monthly': return '月卡'
    case 'consume': return '消费'
    case 'refund': return '退款'
    case 'daily': return '每日领取'
    case 'incentive': return '创作激励'
    case 'revenue': return '创作者收益分成'
    case 'admin_grant': return '管理员发放'
    default: return type
  }
}

export const transactionsColumns: ColumnDef<TransactionRecord>[] = [
  // {
  //   id: 'select',
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && 'indeterminate')
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label='Select all'
  //       className='translate-y-[2px]'
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label='Select row'
  //       className='translate-y-[2px]'
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  // {
  //   accessorKey: 'id',
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title='ID' />
  //   ),
  //   meta: { className: 'hidden sm:table-cell' },
  //   cell: ({ row }) => <div className='w-[80px] truncate' title={row.getValue('id')}>{row.getValue('id')}</div>,
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  {
    accessorKey: 'type',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='类型' />
    ),
    cell: ({ row }) => {
      const type = row.original.type
      return (
        <Badge variant='outline'>{getPaymentTypeLabel(type)}</Badge>
      )
    },
  },
  {
      accessorKey: 'amount',
      header: ({ column }) => (
          <DataTableColumnHeader column={column} title='金额' />
      ),
      cell: ({ row }) => {
          const amount = row.original.amount
          return (
              <span className={amount >= 0 ? 'text-green-600 font-medium' : 'text-red-600 font-medium'}>
                  {amount > 0 ? '+' : ''}{amount}
              </span>
          )
      }
  },
  {
      accessorKey: 'balance',
      header: ({ column }) => (
          <DataTableColumnHeader column={column} title='余额' />
      ),
  },
  {
      accessorKey: 'description',
      header: ({ column }) => (
          <DataTableColumnHeader column={column} title='描述' />
      ),
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='时间' />
    ),
    cell: ({ row }) => {
        try {
            return format(new Date(row.getValue('createdAt')), 'yyyy-MM-dd HH:mm:ss')
        } catch {
            return row.getValue('createdAt')
        }
    },
  },

]
